<template>
  <div>
    <BModal
      ref="rerun-noc-modal"
      size="md"
      title="Re-run NOC AI Matching"
      ok-title="Run Matching"
      cancel-title="Cancel"
      :ok-disabled="submitting"
      @ok="handleSubmit"
      @hidden="resetForm"
    >
      <!-- AI Summary Status -->
      <div v-if="hasAiSummary" class="alert alert-success small mb-3">
        <i class="fas fa-check-circle mr-1"></i>
        <strong>AI Summary available</strong> - Will be used for matching (recommended)
      </div>
      <div v-else class="alert alert-warning small mb-3">
        <i class="fas fa-exclamation-triangle mr-1"></i>
        <strong>No AI Summary</strong> - Generate one first for better accuracy, or enable description below.
      </div>

      <!-- What AI will use -->
      <div class="mb-3">
        <strong class="small text-muted">AI will analyze:</strong>
        <ul class="small mb-0 mt-1">
          <li>Job title</li>
          <li>Categories</li>
          <li v-if="hasAiSummary" class="text-success"><i class="fas fa-check mr-1"></i>AI Summary</li>
          <li v-if="includeDescription">Description (first {{ descriptionMaxChars }} chars)</li>
        </ul>
      </div>

      <hr />

      <b-form-group label="Additional options">
        <b-form-checkbox v-model="includeDescription" switch>
          {{ includeDescription ? 'Include raw description' : 'Do not include raw description' }}
        </b-form-checkbox>
        <small class="text-muted d-block mt-1">
          <span v-if="hasAiSummary">
            The AI summary is already used. Raw description is usually not needed.
          </span>
          <span v-else>
            Enable this if no AI summary is available and you want more context for matching.
          </span>
        </small>
      </b-form-group>

      <b-form-group
        v-if="includeDescription"
        label="Maximum description characters"
        label-for="desc-chars"
        description="Limit how much of the description is sent to the AI (recommended: 500-1000)"
      >
        <b-form-input
          id="desc-chars"
          v-model.number="descriptionMaxChars"
          type="number"
          min="100"
          max="5000"
          step="100"
        ></b-form-input>
      </b-form-group>
    </BModal>
  </div>
</template>

<script>
import { BModal, BFormGroup, BFormCheckbox, BFormInput } from "bootstrap-vue";

export default {
  components: { BModal, BFormGroup, BFormCheckbox, BFormInput },
  props: {
    offerId: {
      required: true,
      type: [String, Number]
    },
    hasAiSummary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      includeDescription: false,
      descriptionMaxChars: 500
    };
  },
  methods: {
    openModal() {
      this.$refs["rerun-noc-modal"].show();
    },
    resetForm() {
      this.includeDescription = false;
      this.descriptionMaxChars = 500;
    },
    async handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.submitting = true;

      try {
        await this.$http.post(`/enroll_admin/offer/${this.offerId}/rerun-noc-matching`, {
          include_description: this.includeDescription,
          description_max_chars: this.includeDescription ? this.descriptionMaxChars : 0
        });

        this.$bvToast.toast("NOC matching job dispatched. Refresh in a few seconds to see results.", {
          title: "Success",
          variant: "success",
          solid: true
        });

        this.$emit("success");
        this.$refs["rerun-noc-modal"].hide();
      } catch (error) {
        this.$bvToast.toast("Failed to re-run NOC matching", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
